/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderContentType } from './orderContentType';
import { AssessmentTypeEnum } from './assessmentTypeEnum';


export interface NotPlannedOrderApiModel { 
    employeeId: number;
    employeeTitleBeforeName: string;
    employeeName: string;
    employeeSurname: string;
    employeeTitleAfterName: string;
    employeePersonalNumber: string;
    employerId: number;
    employerName: string;
    employerAlias: string;
    orderId: number;
    orderType: AssessmentTypeEnum;
    orderContentType: OrderContentType;
    orderNumber: string;
    providerId: number;
    providerName: string;
}
export namespace NotPlannedOrderApiModel {
}


